<!-- TABLE -->
<table class="table cx-order-history-table">
  <thead class="cx-order-history-thead-mobile">
    <th scope="col" class="deliverynumber">
      {{ 'deliveryNotes.deliveryNumber' | cxTranslate }}
    </th>
    <th scope="col" class="deliverymethod">
      {{ 'deliveryNotes.deliveryMethod' | cxTranslate }}
    </th>
    <th scope="col" class="formattedreleasedate">
      {{ 'deliveryNotes.formattedReleaseDate' | cxTranslate }}
    </th>

    <th scope="col" class="trackingcode">
      {{ 'deliveryNotes.trackingCode' | cxTranslate }}
    </th>
    <th scope="col" class="weightKG">
      {{ 'deliveryNotes.weightKG' | cxTranslate }}
    </th>
    <th scope="col" class="units">
      {{ 'deliveryNotes.units' | cxTranslate }}
    </th>
  </thead>
  <tbody>
    @for (deliveryNote of deliveryNotes; track deliveryNote) {
      <tr>
        <!--Delivery Number-->
        <td class="deliverynumber">
          <div class="d-md-none cx-order-history-label">
            {{ 'deliveryNotes.deliveryNumber' | cxTranslate }}
          </div>
          <div class="cx-order-history-value">
            <a
            [routerLink]=" marketplace ? ({
              cxRoute: 'marketplaceDeliveryNoteDetails',
              params: deliveryNote
            } | cxUrl) :
              ({
                cxRoute: 'deliveryNoteDetails',
                params: deliveryNote
              } | cxUrl)
            "
              [state]="{data:{id: deliveryNote?.deliveryNumber}}"
              class="cx-order-history-value"
              >
              {{ deliveryNote?.deliveryNumber }}</a
              >
              @if (deliveryNote?.pdfUrl) {
                <a class="cx-order-history-value" (click)="openPdf(deliveryNote.pdfUrl)">
                  <span class="pl-3">{{ 'deliveryNotes.pdfUrl' | cxTranslate }}</span>
                </a>
              }
            </div>
          </td>
          <!--Delivery Method-->
          <td class="deliverymethod">
            <div class="d-md-none cx-order-history-label">
              {{ 'deliveryNotes.deliveryMethod' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              {{ deliveryNote?.deliveryMethod }}
            </div>
          </td>
          <!--Release Date-->
          <td class="releasedate">
            <div class="d-md-none cx-order-history-label">
              {{ 'deliveryNotes.formattedReleaseDate' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              {{ deliveryNote?.formattedReleaseDate }}
            </div>
          </td>
          <!--Tracking Code-->
          <td class="trackingUrl">
            <div class="d-md-none cx-order-history-label">
              {{ 'deliveryNotes.trackingUrl' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              @if (deliveryNote?.trackingUrl) {
                <a [routerLink]="[]" (click)="openTracking(deliveryNote)" class="cx-order-history-value"
                  >
                  {{ 'deliveryNotes.trackingLink' | cxTranslate }}</a
                  >
                }
              </div>
            </td>
            <!--Weight in KG-->
            <td class="weightKG">
              <div class="d-md-none cx-order-history-label">
                {{ 'deliveryNotes.weightKG' | cxTranslate }}
              </div>
              <div class="cx-order-history-value">
                {{ deliveryNote?.formattedWeightKG }}
              </div>
            </td>
            <!--Units-->
            <td class="units">
              <div class="d-md-none cx-order-history-label">
                {{ 'deliveryNotes.units' | cxTranslate }}
              </div>
              <div class="cx-order-history-value">
                {{ deliveryNote?.units }}
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>